module.exports = __webpack_public_path__ + "static/media/211.96035bd6.jpg";